<template>
  <v-container class="mt-4">
    <v-data-table
      class="border-table"
      density="compact"
      :headers="headers"
      hide-no-data
      item-value="id"
      :items="activities">
      <template #item="{ item }">
        <tr>
          <td>
            <CalcInputInline
              field="name"
              :id="item.id" />
          </td>
          <td>
            <CalcInputInline
              field="gross_salary_activity"
              :id="item.id"
              type="number" />
          </td>
          <td>{{ item.personnel_hourly_rate_activity }}</td>
          <td class="text-no-wrap">
            <EmbeddedTableActionButtons
              data-cy="activity"
              :clone-action="() => cloneAction(item.id)"
              :delete-action="() => deleteAction(item.id)" />
          </td>
        </tr>
      </template>

      <!-- Removed pagination, create button -->
      <template #[`header.actions`]>
        <div class="pb-4 text-center">
          <v-btn
            class="mx-1 px-0 mt-4"
            color="#ECE6F0"
            elevated="26"
            max-width="40"
            min-width="40"
            rounded="lg"
            data-cy="add-element-activity"
            @click="addAction">
            <v-icon
              color="#0F6DAC"
              size="x-large">
              mdi-plus
            </v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script setup>
import { computed, ref } from "vue";
import { useTranslation } from "i18next-vue";
import EmbeddedTableActionButtons from "@/components/DataTable/EmbeddedTableActionButtons.vue";

import i18next from "i18next";
import { useSpaceStore } from "@/stores/spaceStore";
import { useRouter } from "vue-router";
import CalcInputInline from "@/components/Elements/CalcInputInline.vue";

const { t } = useTranslation();
const spaceStore = useSpaceStore();

const popupForm = ref(false);

const headers = computed(() => [
  {
    title: t("entities.activity.fields.name"),
    align: "start",
    sortable: false,
    key: "name"
  },
  {
    title: t("entities.activity.fields.gross_salary_activity"),
    key: "gross_salary_activity",
    sortable: false
  },
  {
    title: t("entities.activity.fields.personnel_hourly_rate_activity"),
    key: "personnel_hourly_rate_activity",
    sortable: false
  },
  {
    title: "",
    key: "actions",
    sortable: false
  }
]);

const props = defineProps({
  locationId: {
    type: String,
    required: true
  }
});

const activities = computed(() => {
  return Object.entries(spaceStore.calculationElements).reduce(
    (result, [id, element]) => {
      if (
        id.endsWith("activity") &&
        spaceStore.calculationElements[props.locationId].children.includes(id)
      ) {
        result.push(Object.assign({}, element, { id }));
      }
      return result;
    },
    []
  );
});

const router = useRouter();

const addAction = () => {
  spaceStore.createElement("activity", props.locationId);
};

const cloneAction = (id) => {
  spaceStore.prepareClone(id);
  spaceStore.cloneOnServer(props.locationId, false);
};

const deleteAction = (id) => {
  spaceStore.removeElement(id);
};
</script>
